module.exports = __webpack_public_path__ + "static/media/Main.d5a51ac8.png";